import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import React from 'react';
import styled from '@emotion/styled';
import { CloseIcon, HamburgerIcon } from "@argo/ui-elements";
import { breakpoints, size } from "@argo/principles";
import { HAMBURGER_MENU_ID, NAV_HEIGHT } from '../utils/constants';
var Toggle = styled.label(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: inline-block;\n  position: relative;\n  width: ", "px;\n  height: ", "px;\n  padding: ", "px ", "px;\n  padding-right: ", "px;\n  transform: rotateY(0deg);\n  // transition: transform .4s ease;\n\n  > svg {\n    position: absolute;\n    // backface-visibility: hidden;\n    // transform-style: preserve-3d;\n\n    &:first-of-type {\n      // transform: rotateY(0deg);\n      display: inline-block;\n    }\n\n    &:last-of-type {\n      // transform: rotateY(180deg);\n      display: none;\n    }\n  }\n\n  @media (min-width: ", "px) {\n    padding-right: ", "px;\n    padding-left: ", "px;\n    margin-right: ", "px;\n  }\n"])), function (_ref) {
  var iconSize = _ref.iconSize;
  return iconSize;
}, function (_ref2) {
  var iconSize = _ref2.iconSize;
  return iconSize;
}, function (_ref3) {
  var iconSize = _ref3.iconSize;
  return (NAV_HEIGHT - iconSize) / 2;
}, size.xs, size.sm, breakpoints.lg, size.md / 2, size.md / 2, size.md / 2);
var ToggleBox = styled.input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: none;\n\n  &:checked {\n    // transform: rotateY(180deg);\n\n    + label svg{\n      &:first-of-type {\n        // transform: rotateY(0deg);\n        display: none;\n      }\n\n      &:last-of-type {\n        // transform: rotateY(180deg);\n        display: inline-block;\n      }\n    }\n  }\n"])));
var HamburgerToggler = function HamburgerToggler(_ref4) {
  var onMenuClick = _ref4.onMenuClick,
    menuOpenState = _ref4.menuOpenState,
    iconSize = _ref4.iconSize;
  var isMenuOpen = menuOpenState.isMenuOpen,
    menuId = menuOpenState.menuId;
  var isNavOpen = isMenuOpen && menuId === HAMBURGER_MENU_ID;
  return React.createElement(React.Fragment, null, React.createElement(ToggleBox, {
    type: 'checkbox',
    id: HAMBURGER_MENU_ID
  }), React.createElement(Toggle, {
    htmlFor: HAMBURGER_MENU_ID,
    iconSize: iconSize,
    onClick: onMenuClick,
    className: 'menu-item',
    "data-menu-state": isNavOpen ? "open" : "closed"
  }, React.createElement(HamburgerIcon, {
    color: "white",
    size: iconSize
  }), React.createElement(CloseIcon, {
    color: "white",
    size: iconSize
  })));
};
export default HamburgerToggler;